export function stringToKey(str: string) {
  // Null-safe so the XLSX util's mirror (utils/service-provider-xlsx.ts) stays
  // behaviourally identical — category matching crosses that boundary.
  return (str || '').toLowerCase().replace(/\s+/g, '-');
}
